import { DiscountTypeEnum } from 'src/app/enum/discount-type.enum';
import { TunnelData } from '../../tunnel/tunnel-data';
import { DiscountPrices } from '../kitchen/kitchen-configuration-price';
import { FidelityCardPointSimulationDto } from 'src/app/services/fidelity/fidelity';

export class StorageTunnelData extends TunnelData {
  public bom: any;
  public HBMProjectUUID: string;
  public configId: string;
  public discountValue: DiscountTypeEnum;
  public downPayment: number;
  public opportunityNumber: number;
  public mensuality: number;
  public duration: number;
  public totalFundingCost: number;
  public offerTable: any;
  public totalPriceBom: number;
  public totalPriceBomWithDiscount: {
    discountPrices?: DiscountPrices;
    amount: number;
  };
  public interest: number;
  public mlData: any;
  public txtAssurance: string;
  public vac: string;

  public fidelityCardPoint: FidelityCardPointSimulationDto[] = [];

  private mapDiscountValueToEnum(value: number): DiscountTypeEnum | undefined {
    switch (value) {
      case 0:
        return DiscountTypeEnum.Discount0;
      case 5:
        return DiscountTypeEnum.Discount5;
      case 10:
        return DiscountTypeEnum.Discount10;
      case 20:
        return DiscountTypeEnum.Discount20;
      default:
        return undefined;
    }
  }

  constructor() {
    super();
    this.init();
  }

  initFromConfig(config: any) {
    if (config === null) {
      return;
    }

    this.discountValue =
      config.discount !== undefined ? this.mapDiscountValueToEnum(config.discount) : this.discountValue;

    this.downPayment = config.downPayment !== undefined ? config.downPayment : this.downPayment;
    this.interest = config.interest !== undefined ? config.interest : this.interest;

    this.offerTable = config.offers !== undefined ? JSON.parse(config.offers) : this.offerTable;

    this.totalPriceBom = config.totalPriceBom !== undefined ? config.totalPriceBom.amount : this.totalPriceBom;

    this.totalPriceBomWithDiscount =
      config.totalPriceBom !== undefined ? config.totalPriceBom : this.totalPriceBomWithDiscount;

    this.mensuality = config.mensuality !== undefined ? config.mensuality : this.mensuality;

    this.duration = config.duration !== undefined ? config.duration : this.duration;

    this.totalFundingCost = this.totalFundingCost !== undefined ? config.montantTotal : this.totalFundingCost;

    if (config.bom) {
      this.bom = JSON.parse(config.bom);
    }
    this.configId = config.id;

    this.discountValue =
      config.discount !== undefined ? this.mapDiscountValueToEnum(config.discount) : this.discountValue;

    this.mlData = config.mlData !== undefined ? JSON.parse(config.mlData) : this.mlData;

    this.txtAssurance = config.txtAssurance !== undefined ? config.txtAssurance : this.txtAssurance;

    this.vac = config.vac !== undefined ? config.vac : this.vac;

    this.HBMProjectUUID = config.projectUUID !== undefined ? config.projectUUID : this.HBMProjectUUID;
  }

  init() {
    this.bom = undefined;
    this.HBMProjectUUID = undefined;
    this.configId = undefined;
    this.totalFundingCost = 0;
    this.mensuality = 0;
    this.duration = 0;
    this.interest = 0;
    this.offerTable = undefined;
    this.downPayment = 0;
    this.totalPriceBom = 0;
    this.mlData = undefined;
    this.txtAssurance = '';
    this.vac = '';
    this.discountValue = DiscountTypeEnum.Discount0;
  }
}
